import React from 'react'
import CardContent from '../CardContent/CardContent.component'
import CardHeader from '../CardHeader/CardHeader.component'

import './Card.css'

// mui
import { Divider, Paper } from '@mui/material'

const Card = ({ header, children }) => {

    /*
        header:
        - title
        - linkText
        - onLinkClick handler
    */

    return (<Paper variant='outlined' sx={{ maxWidth: "50vw"}}>
        { header && <CardHeader {...header} /> }
        <Divider />
        <CardContent>{children}</CardContent>
        </Paper>)
}

export default Card